// src/components/VitalsDashboard.js
import React from 'react';
import { Box, Typography, Paper, List, ListItem, useTheme } from '@mui/material';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import VitalsSparkline from './VitalsSparkline'; // Import our new graph component

// A map to give our vitals friendly names and colors
const VITAL_METADATA = {
    bp_systolic: { label: 'Systolic BP', color: '#d32f2f' },
    bp_diastolic: { label: 'Diastolic BP', color: '#d32f2f' },
    heart_rate: { label: 'Heart Rate', color: '#f57c00' },
    weight_kg: { label: 'Weight (kg)', color: '#1976d2' },
    oxygen_saturation: { label: 'SpO2 (%)', color: '#388e3c' },
    temperature_celsius: { label: 'Temp (°C)', color: '#7b1fa2' },
};

export default function VitalsDashboard({ vitals, onOpenModal }) {
    const theme = useTheme();

    if (!vitals || vitals.length === 0) return null;

    return (
        <Paper elevation={2} sx={{ p: { xs: 1.5, md: 2 }, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <MonitorHeartIcon sx={{ mr: 1, color: 'text.secondary' }} /> Vitals
            </Typography>
            <List sx={{ p: 0 }}>
                {vitals.map(vital => (
                    <ListItem
                        key={vital.parameter_name}
                        divider
                        onDoubleClick={() => onOpenModal({ item_type: 'vitals', title: VITAL_METADATA[vital.parameter_name]?.label || vital.parameter_name }, vital)}
                        sx={{ p: 1, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' }, '&:last-child': { border: 0 } }}
                    >
                        <VitalsSparkline
                            data={vital.series}
                            title={VITAL_METADATA[vital.parameter_name]?.label || vital.parameter_name}
                            color={VITAL_METADATA[vital.parameter_name]?.color || theme.palette.primary.main}
                        />
                    </ListItem>
                ))}
            </List>
        </Paper>
    );
}